// extracted by mini-css-extract-plugin
export default {"button":"button_button__QVyak","secondary":"button_secondary__PP0+M"};